<template>
  <div class="about-us">
    <div class="header-img">
      <img src="@/assets/images/about-us-banner.png" alt>
    </div>
    <div class="intor">
      <!-- <p> 江苏省企业信息化协会在江苏省经济和信息化委员会
        指导下于2015年11月9日成立。协会现在拥有包括众多标
        杆企业、两化融合示范单位在内的500余家会员单位，协
        会以打造健康的江苏省两化融合生态体系为使命，坚持共
        建共创共享共赢的价值观，坚定走“市场化运营、专业化服
        务”的运营路线，服务政府、服务市场，打造一个全省CIO
        大家庭。现在协会坚持多点覆盖的思路，在江苏设立南京、
        无锡、苏州、南通、泰州、常熟、昆山及宜兴代表处、盐
        城CIO联盟9大地方分支机构，更好地服务于政府、产业、
        学校、研究、金融、中介服务机构、企业用户合作7大合作
      体系。</p>-->
      <p v-html="aboutus.DetailDesc"></p>
      <!-- <div class="unfold">
        <span @click="onPull()">{{isShowAll?'收起':'展开'}} <i :class="{'rotate':isShowAll}"></i></span>
      </div>-->
    </div>
    <div class="study-info">
      <h5>联系协会</h5>
      <div class="info-list">
        <div class="info">
          <i class="phone"></i>
          <span>025-82229212</span>
        </div>
        <div class="info">
          <i class="mobile"></i>
          <span>15162486976</span>
        </div>
        <div class="info">
          <i class="place"></i>
          <span>江苏省南京市鼓楼区广州路37号江苏科技大厦22楼2212室</span>
        </div>
        <div class="info">
          <i class="email"></i>
          <span>jseia@jseia.org.cn</span>
        </div>
      </div>
      <div class="map">
        <iframe src="map.html" frameborder="0" scrolling="no"
          style="width:100%;height:100%;"></iframe>
      </div>
    </div>
    <div class="study-info">
      <h5>留言</h5>
      <div class="form">
        <div class="input">
          <span>姓名</span>
          <input type="text" placeholder="请输入您的姓名" v-model="feedBackData.Name">
        </div>
        <div class="input">
          <span>联系电话</span>
          <input type="text" placeholder="请输入联系电话" v-model="feedBackData.Tel">
        </div>
        <div class="input">
          <span>留言内容</span>
          <textarea id cols="30" rows="10" placeholder="请输入您要说的话"
            v-model="feedBackData.Content"></textarea>
        </div>
      </div>
    </div>
    <button class="btn-main btn-submit" @click="backSubmit()">提交</button>
    <footer-logo></footer-logo>
  </div>
</template>

<script>
  import footerLogo from '@/components/footerLogo.vue'
  export default {
    components: {
      'footer-logo': footerLogo
    },
    data() {
      return {
        feedBackData: {
          Name: '',
          Tel: '',
          Content: ''
        },
        isShowAll: false,
        aboutData: {
          cateNo: 'AboutUs'
        },
        aboutus: {
          DetailDesc: ''
        }
      }
    },
    created() {
      this.getAbout()
    },
    methods: {
      onPull() {
        this.isShowAll = !this.isShowAll
      },
      getAbout() {
        this.$fetch('/api/CmsCategory/GetCategoryInfo', this.aboutData).then(result => {
          console.log(result)
          this.aboutus = result
        })
      },
      backSubmit() {
        if (!this.feedBackData.Content) {
          this.$dialog.toast({
            mes: '请填写您的留言',
            timeout: 1500
          })
          return false
        }
        if (!this.feedBackData.Tel) {
          this.$dialog.toast({
            mes: '请填写您的电话',
            timeout: 1500
          })
          return false
        }
        this.$post('/api/Feedback/Add', this.feedBackData).then(result => {
          this.feedBackData = {}
          this.$dialog.toast({
            mes: '留言提交成功',
            timeout: 1500
          })
        })
      }
    }
  }

</script>

<style lang="less" scoped>
  .about-us {
    background: #fff;
  }

  input::-webkit-input-placeholder,
  textarea::-webkit-input-placeholder {
    color: #ccc;
  }

  .header-img {
    width: 100%;
    height: 320 / @rem-size;
    overflow: hidden;
  }

  .intor {
    background: #fff;
    line-height: 45 / @rem-size;
    padding: 20 / @rem-size 24 / @rem-size;

    p {
      font-size: 28 / @rem-size;
      color: #999;
    }
  }

  .unfold {
    text-align: center;
    margin-top: 26 / @rem-size;

    span {
      display: inline-block;
      font-size: 28 / @rem-size;
      color: #999;
      padding-right: 55 / @rem-size;
      position: relative;

      i {
        display: block;
        width: 35 / @rem-size;
        height: 25 / @rem-size;
        background-image: url('../assets/images/pull.png');
        background-size: 100% 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        margin: auto;

        &.rotate {
          transform: rotate(180deg);
        }
      }
    }
  }

  .study-info {
    background: #fff;
    padding-bottom: 30 / @rem-size;

    h5 {
      font-size: 32 / @rem-size;
      color: #000033;
      padding-left: 46 / @rem-size;
      font-weight: normal;
      position: relative;

      &::after {
        display: block;
        content: '';
        width: 4 / @rem-size;
        height: 32 / @rem-size;
        background: #005fd5;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 24 / @rem-size;
        margin: auto;
      }
    }

    .info-list {
      padding: 15 / @rem-size 24 / @rem-size 0;

      .info {
        padding-left: 80 / @rem-size;
        font-size: 28 / @rem-size;
        line-height: 50 / @rem-size;
        margin-top: 10 / @rem-size;
      }
    }

    .map {
      padding: 0 24 / @rem-size;
      margin-top: 10 / @rem-size;
      width: 100%;
      height: 320 / @rem-size;
    }

    .form {
      padding: 0 24 / @rem-size;

      .input {
        height: auto;

        span {
          font-size: 28 / @rem-size;
          color: #333;
          display: block;
          line-height: 78 / @rem-size;
        }

        input {
          width: 100%;
          height: 80 / @rem-size;
          background: #f7f7f7;
          border-radius: 8 / @rem-size;
          font-size: 28 / @rem-size;
          padding: 0 20 / @rem-size;
        }

        textarea {
          width: 100%;
          height: 200 / @rem-size;
          background: #f7f7f7;
          border-radius: 8 / @rem-size;
          font-size: 28 / @rem-size;
          padding: 20 / @rem-size;
        }
      }
    }
  }

  .btn-submit {
    display: block;
    margin: auto;
    margin-top: 10 / @rem-size;
    width: 360 / @rem-size;
    height: 80 / @rem-size;
    border-radius: 8 / @rem-size;
    font-size: 36 / @rem-size;
  }

  .mobile {
    background: url('../assets/images/mobile.png');
    background-size: 100% 100%;
  }

</style>
